import React from "react";
import counterpart from "counterpart";
import ClipboardButton from "react-clipboard.js";
import Icon from "../Icon/Icon";
import { Tooltip } from "bitshares-ui-style-guide";

const CopyButton = ({
  className = "button",
  text = "",
  tip = "tooltip.copy_tip",
  dataPlace = "right",
  buttonIcon = "clippy",
  buttonText = "",
  useDiv = true
}) => {
  const button = /*#__PURE__*/React.createElement(ClipboardButton, {
    "data-clipboard-text": text,
    className: className
  }, !buttonText ? /*#__PURE__*/React.createElement(Icon, {
    name: buttonIcon,
    title: "icons.clippy.copy"
  }) : buttonText);
  return /*#__PURE__*/React.createElement(Tooltip, {
    placement: dataPlace,
    title: counterpart.translate(tip)
  }, useDiv ? /*#__PURE__*/React.createElement("div", null, button) : /*#__PURE__*/React.createElement("span", null, button));
};

export default CopyButton;